import type { AuthMeResponse } from '@igs/shared';
import { apiFetch } from '../../lib/api.js';

const ME_PATH = '/api/admin/auth/me';
const LOGOUT_PATH = '/api/admin/auth/logout';
export const LOGIN_REDIRECT_PATH = '/api/admin/auth/login';

export async function fetchMe(signal?: AbortSignal): Promise<AuthMeResponse> {
  const opts: { signal?: AbortSignal } = {};
  if (signal) opts.signal = signal;
  return apiFetch<AuthMeResponse>(ME_PATH, opts);
}

export async function logout(): Promise<void> {
  await apiFetch(LOGOUT_PATH, { method: 'POST' });
}
